module.exports = __webpack_public_path__ + "img/xml.f7e60be1.svg";